// extracted by css-extract-rspack-plugin
export default {"cropped-link":"SourceAccountsModal-module__cropped-link--Go3zh","croppedLink":"SourceAccountsModal-module__cropped-link--Go3zh"};